import React from 'react';
import './style.scss';
import clsx from 'clsx';

const FlippingCardBackOverlay = ({ visible, hide }) => (
  <div
    className={clsx('fc-overlay', visible && 'fc-overlay-visible')}
    onClick={visible ? hide : null}
  />
);

export default FlippingCardBackOverlay;
